import { Field } from '../classes/field';
import { FieldType } from '../types/field-type';

export function rosbagPlayerFields(speedOptions: number[]): Field[] {
  return [
    new Field(
      FieldType.MINI_SELECT_SINGLE,
      false,
      1,
      undefined,
      undefined,
      speedOptions,
      undefined,
      { suffix: 'x' },
      'playback_speed'
    ),
  ];
}
